import {Check, Image as ImageIcon, Layers, List, MessageSquare, PlaySquare} from "lucide-react";
import React from "react";
import {Button} from "omoplay";
import {copyMessage} from "../../api/message/volatility-message.api";

const OneTimeMessageSelection = ({ id, selectedType, campaignName, onSelect, onCampaignName }) => {
    const types = [
        { id: 'FI', label: '기본 텍스트', icon: <MessageSquare size={32}/>, desc: '이미지와 텍스트로 구성된 기본형' },
        { id: 'FW', label: '와이드 이미지', icon: <ImageIcon size={32}/>, desc: '큰 이미지로 시선을 사로잡는 형' },
        { id: 'FL', label: '와이드 리스트', icon: <List size={32}/>, desc: '여러 항목을 리스트로 나열' },
        { id: 'FC', label: '캐러셀 피드', icon: <Layers size={32}/>, desc: '좌우로 넘겨보는 카드형 메시지' },
        { id: 'FP', label: '프리미엄 동영상', icon: <PlaySquare size={32}/>, desc: '영상 자동 재생으로 몰입도 증대' }
    ];

    return (
        <div className="w-full max-w-5xl mx-auto animate-fadeIn">
            {/* 상단 네비게이션 버튼 */}
            <div className="flex-center-all mb-10 gap-4">
                {/*
                <Button
                    variants="default"
                    value="예전 페이지로 가기"
                    onClick={() => {
                        window.location.href = "/volatility-message/edit" + window.location.search
                    }}
                />
                */}
                <Button
                    variants="secondary"
                    value="복제하기"
                    disabled={!id}
                    onClick={() => {
                        if (window.confirm("정말 복제하시겠습니까?")) {
                            copyMessage(id).then(() => {
                                window.location.href = "/volatility-message"
                            })
                        }
                    }}
                />
            </div>

            {/* [추가됨] 캠페인명 입력 필드 */}
            <div className="max-w-xl mx-auto mb-12">
                <label className="block text-sm font-bold text-gray-700 mb-2 ml-1">
                    메시지 캠페인명
                </label>
                <div className="relative">
                    <input
                        type="text"
                        value={campaignName} // 부모 컴포넌트에서 전달받은 state
                        onChange={(e) => onCampaignName(e.target.value)}
                        placeholder="관리할 캠페인 이름을 입력해주세요 (예: 3월 정기 세일 알림)"
                        className="w-full px-5 py-4 rounded-xl border border-gray-300 text-gray-800 placeholder-gray-400 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 outline-none transition-all shadow-sm"
                    />
                </div>
            </div>

            {/* 메시지 타입 선택 타이틀 */}
            <h2 className="text-xl font-bold text-gray-800 mb-6 text-center">어떤 메시지를 보내시겠습니까?</h2>

            {/* 타입 그리드 */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {types.map((t) => (
                    <div
                        key={t.id}
                        onClick={() => {
                            if (t.id !== "FV") {
                                onSelect(t.id)
                            }
                        }}
                        className={`cursor-pointer p-8 rounded-2xl border-2 transition-all flex flex-col items-center text-center gap-4 hover:shadow-lg
      ${selectedType === t.id
                            ? 'border-indigo-600 bg-indigo-50 text-indigo-700 shadow-md ring-2 ring-indigo-200'
                            : `border-gray-200 bg-white text-gray-600 ${t.id !== 'FP' ? 'hover:border-indigo-300 hover:bg-gray-50' : ''}`}
    `}
                    >
                        <div className={`p-4 rounded-full ${selectedType === t.id ? 'bg-white' : 'bg-gray-100'}`}>
                            {t.icon}
                        </div>
                        <div>
                            <div className="font-bold text-lg mb-1">{t.label}</div>
                            <div className="text-sm opacity-70">{t.desc}</div>
                        </div>
                        {selectedType === t.id && <div className="mt-2 text-indigo-600 font-bold text-sm"><Check size={16} className="inline mr-1"/>선택됨</div>}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default OneTimeMessageSelection;